"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lamezia-terme": {
    "2b7e5904": [{
      "hkey": "090e2384",
      "slug": "nicastro-sambiase",
      "name": "Nicastro-Sambiase",
      "primary": true,
      "skipSearch": false
    }],
    "nicastro": [{
      "hkey": "090e2384",
      "slug": "nicastro-sambiase",
      "name": "Nicastro-Sambiase",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0557d874": [{
      "hkey": "090e2384",
      "slug": "nicastro-sambiase",
      "name": "Nicastro-Sambiase",
      "primary": true,
      "skipSearch": false
    }],
    "sambiase": [{
      "hkey": "090e2384",
      "slug": "nicastro-sambiase",
      "name": "Nicastro-Sambiase",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;